import React from 'react'

import {useProductList} from '../util/product-list-context'
import {Box, SimpleGrid} from '@salesforce/retail-react-app/app/components/shared/ui'
import {isHydrated} from '@salesforce/retail-react-app/app/utils/utils'

import PageHeader from './page-header'
import ProductListTopPanel from './product-list-top-panel'
import RefinementsDrawer from './refinements-drawer'
import BottomElements from './bottom-elements'
import ProductTile, {Skeleton as ProductTileSkeleton} from '../../../components/product-tile'
import {useWishlistActions} from '../../../hooks/use-wishlist-actions'
import useEinstein from '../../../hooks/use-einstein'

const ProductListFamily = () => {
    const {category, productSearchResult, isLoading, isRefetching, isFetched} = useProductList()
    const {wishlist, addProductToWishlist, removeProductFromWishlist} = useWishlistActions()
    const einstein = useEinstein()
    const products = productSearchResult?.hits?.filter(
        (product) =>
            product?.variants?.every(
                (variant) =>
                    variant?.variationValues?.size && variant?.variationValues?.color
            ) || product?.hitType === 'set'
    )
    const showSkeletons = ((isLoading || isRefetching) && !isFetched) || !productSearchResult?.hits

    return (
        <>
            {/* Header */}
            <PageHeader isFamily />

            <Box as="section">
                {/* Top PLP panel */}
                <ProductListTopPanel showTopNavigation={false} />

                <Box borderBottomWidth={1} borderColor="borderGray">
                    <SimpleGrid
                        as="ul"
                        className="product-list-grid"
                        listStyleType="none"
                        columns={[2, 2, 3, 4, 4, 5]}
                        spacingX="10px"
                        spacingY={{base: 24, lg: 70}}
                        pb={['70px', null, null, '80px']}
                    >
                        {isHydrated() && showSkeletons
                            ? new Array(20)
                                  .fill(0)
                                  .map((value, index) => (
                                      <ProductTileSkeleton key={`skeleton-${index}`} />
                                  ))
                            : products?.map((product, index) => {
                                  const isInWishlist = !!wishlist?.customerProductListItems?.find(
                                      (item) => item?.productId === product.productId
                                  )

                                  return (
                                      <Box key={product.productId} as="li">
                                          <ProductTile
                                              className="product-tile"
                                              data-testid={`sf-product-tile-${product.productId}`}
                                              product={product}
                                              isFavourite={isInWishlist}
                                              isFavIconInTitle={true}
                                              isRefreshingData={isRefetching && isFetched}
                                              onClick={() =>
                                                  einstein.sendClickCategory(category, product)
                                              }
                                              onFavouriteToggle={(toBeFavourite) => {
                                                  const action = toBeFavourite
                                                      ? addProductToWishlist
                                                      : removeProductFromWishlist
                                                  return action(product)
                                              }}
                                              dynamicImageProps={{
                                                  widths: [
                                                      'calc((100vw - 10px) / 2)',
                                                      'calc((100vw - 10px) / 2)',
                                                      'calc((100vw - 20px) / 3)',
                                                      'calc((100vw - 30px) / 4)',
                                                      'calc((100vw - 30px) / 4)',
                                                      'calc((100vw - 40px) / 5)'
                                                  ]
                                              }}
                                              listHasNoMargin={true}
                                              index={index}
                                              isImageLazyLoading={index > 4}
                                          />
                                      </Box>
                                  )
                              })}
                    </SimpleGrid>
                </Box>

                {/* PLP Bottom */}
                <BottomElements category={category} />

                {/* Drawer for filter options */}
                <RefinementsDrawer />
            </Box>
        </>
    )
}

ProductListFamily.propTypes = {}

export default ProductListFamily
